// extracted by mini-css-extract-plugin
module.exports = {"title":"Title_title__SEYIO","small":"Title_small__rAnKV","medium":"Title_medium__PPW3f","big":"Title_big__ANjgh","bold":"Title_bold__uhNvn"};